import config from '@iotv/config'
import { CommonBusinessObject, DynamicIndexObjectType, IGeoModelCommon, isNonNaNNumber, isPosition, Position, ValidTimeZone } from '@iotv/iotv-v3-types'
import { ModelCommon } from '../../model/ModelCommon'
import { supportedTZs } from '../../selectedConfig'
import { ConstrainedUserAttDefs, UserAttributeDefs } from '../../types/ModelTypes'
import { convertLatLngLocationToId } from '../../util/geo/S2/conversion'
import { isNumber } from '../../util/number'

const debug = !process.env.AWS_SESSION_TOKEN && false

const typeName = 'GeoModelCommon'

export const setDskFromLocation = function (this: GeoModelCommon) {
  if (this.location && isPosition(this.location)) {
    this.dsk = convertLatLngLocationToId(this.location, this.cellLevel)
  }
}

export type { IGeoModelCommon }

export class GeoModelCommon extends ModelCommon implements IGeoModelCommon, DynamicIndexObjectType {
  constructor({ ...ob }: CommonBusinessObject & IGeoModelCommon) {
    super(ob.type ?? typeName, { ...ob })
    //this.dpk = this.type
    if (isNonNaNNumber(ob.cellLevel)) {
      this.cellLevel = ob.cellLevel
    }
    if (isPosition(ob.location)) {
      const cellLevel = isNonNaNNumber(ob.cellLevel) ? ob.cellLevel : config.app.geo.S2.defaultLevel + 2
      this.dsk = convertLatLngLocationToId(ob.location, cellLevel)
    }
  }

  location?: Position
  locationSysUpdateable?: boolean
  dsk?: string
  dpk?: string
  cellLevel?: number
  tz?: ValidTimeZone

  get location_lat() {
    return this.location?.lat
  }
  set location_lat(val: number | undefined) {
    if (isNumber(val)) {
      if (!this.location) Object.assign(this, { location: {} })
      if (val && this.location) this.location.lat = val
      setDskFromLocation.apply(this)
    }
  }

  get location_lng() {
    return this.location?.lng
  }
  set location_lng(val: number | undefined) {
    if (isNumber(val)) {
      if (!this.location) Object.assign(this, { location: {} })
      if (val && this.location) this.location.lng = val
      setDskFromLocation.apply(this)
    }
  }

  get elevation() {
    return this.location?.elevation
  }
  set elevation(val: number | undefined) {
    if (isNumber(val)) {
      if (!this.location) Object.assign(this, { location: {} })
      if (this.location) this.location.elevation = val
    }
  }

  set s2CellLevel(level: number | undefined) {
    if (isNonNaNNumber(level)) {
      this.cellLevel = Math.round(level)
      if (this.location) {
        this.dsk = convertLatLngLocationToId(this.location, this.cellLevel)
      }
    }
  }

  get s2CellLevel(): number | undefined {
    return this.cellLevel
  }

  getUserAttributes(): ConstrainedUserAttDefs<DynamicIndexObjectType> & UserAttributeDefs {
    const { type, ...others } = super.getUserAttributes()

    return {
      // type: {
      //   type: 'String',
      //   editable: false,
      // },
      name: {
        type: 'String',
        editable: true,
      },
      location_lat: {
        type: 'Number',
        precision: 5,
        label: 'Lat',
        editable: true,
        limits: {
          min: -90,
          max: 90,
        },
      },
      location_lng: {
        type: 'Number',
        precision: 5,
        label: 'Lng',
        editable: true,
        limits: {
          min: -180,
          max: 180,
        },
      },
      // locationSysUpdateable: {
      //   type: 'Boolean',
      //   label: 'Allow updates',
      // },
      tz: {
        type: 'Enum',
        editable: true,
        enumKv: Object.fromEntries(supportedTZs.map((tz) => [tz, tz])),
      },
    }
  }

  getLatLon(): Position | undefined {
    return this.location_lat && this.location_lng ? { lat: this.location_lat, lng: this.location_lng } : undefined
  }
}
